var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-alert', {
    staticClass: "warning-alert notice-alert text-body-2 mb-4",
    style: _vm.noticeStyle,
    attrs: {
      "border": "left",
      "colored-border": "",
      "color": _vm.color,
      "icon": _vm.icon,
      "elevation": _vm.elevation,
      "type": _vm.type
    }
  }, [_c('div', {
    staticClass: "warning__layout ml-2"
  }, [_c('div', {
    staticClass: "warning__text"
  }, [_vm._t("default")], 2), _vm.$slots.button ? _c('div', {
    staticClass: "warning__actions"
  }, [_vm._t("button")], 2) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }